import React from "react";
import Classes from "./styles/style.module.css";
import { Link } from "react-router-dom";

const SmallBanner = (props) => {
  return (
    <Link to={props.href} target={props.linkNewTab ? "_blank" : "_self"}>
      <div className={Classes.bannerContainer}>
        {props.glow && <div className={Classes.border}></div>}
        <div
          className={Classes.bannerWrapper}
          style={{ padding: props.glow ? "2px" : 0 }}
        >
          <img src={props.src} alt="banner" />
          <h5>{props.title}</h5>
          {props.showText && (
            <div className={Classes.textContainer}>
              <p>{props.title}</p>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default SmallBanner;
